import {Dispatch, SetStateAction, useState} from 'react'
import {
    NaturalReferencingPageSpeedDataResponse, NaturalReferencingPageSpeedResponse,
} from '../../../@types'
import {useQuery} from 'react-query'
import {Get} from '../../../../setup'
import {TransformPageSpeedResponse} from '../../../pages/natural-referencing'

const PAGE_SPEED_DATA = process.env.REACT_APP_STATISTICS_PAGE_SPEED_DATA || 'get-page-speed'

type Props = {
    setData: Dispatch<SetStateAction<NaturalReferencingPageSpeedDataResponse>>
}

export const usePageSpeedData = ({setData}: Props) => {

    const [error, setError] = useState<string | null>(null);

    const {refetch} = useQuery(
        'PAGE_SPEED_DATA',
        () => Get<NaturalReferencingPageSpeedResponse>({endpoint: PAGE_SPEED_DATA}),
        {
            onSuccess: ({pageSpeedData}) => {

                setTimeout(() => {
                    setData(TransformPageSpeedResponse(pageSpeedData))
                }, 500)
                setError(null);
            },
            onError: (err: any) => {
                setError(err.message || 'Une erreur est survenue')
            },
        },
    )

    return {error, refetch}
}